export const ANALYTICS_PATHS = {
  ROOT: '/analytics',
  SUPPORT_OVERVIEW: '/analytics/support/overview',
  SUPPORT_PERFORMANCE: '/analytics/support/performance',
  INFLOW_OVERVIEW: '/analytics/inflow/overview',
  INFLOW_MESSAGE_METRICS: '/analytics/inflow/message-metrics',
  INFLOW_TICKET_METRICS: '/analytics/inflow/ticket-metrics',
} as const;
